import { createContext, useContext } from "react";

export const FitimetContext = createContext({});

export const useFitimetContext = () => useContext(FitimetContext);
